<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
    import { ACNE_SCAR_OPTIONS } from '../types/acne-scar'

    export let data: Record<string, any>
</script>

<div class="scar-list">
    {#each ACNE_SCAR_OPTIONS as option (option.key)}
        <label class="scar-row" class:selected={option.key === 'boxcar'}>
            <input type="checkbox" disabled checked={option.key === 'boxcar'} />
            <span class="scar-label">
                {option.label}
                <span class="scar-tooltip-icon"><Fa icon={faCircleQuestion} /></span>
            </span>
        </label>
    {/each}
</div>

<style>
    .scar-list {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
        gap: 8px;
        width: 100%;
    }
    .scar-row {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 14px;
        border-radius: 8px;
        background: #f8f9fa;
        min-width: 0;
    }
    .scar-row.selected {
        background: var(--cs2-accent-hover, #17be5e);
    }
    .scar-row input[type='checkbox'] {
        width: 16px;
        height: 16px;
        accent-color: var(--cs2-accent, #1bdf6f);
        flex-shrink: 0;
    }
    .scar-label {
        display: flex;
        align-items: center;
        gap: 6px;
        min-width: 0;
        font-weight: 600;
        font-size: 0.85rem;
        color: #212529;
    }
    .scar-row.selected .scar-label {
        color: #1f2937;
    }
    .scar-tooltip-icon {
        font-size: 0.72rem;
        color: #adb5bd;
    }
    .scar-row.selected .scar-tooltip-icon {
        color: #1f2937;
        opacity: 0.75;
    }
</style>
